module.exports = __webpack_public_path__ + "img/login-bk.a48edb34.jpeg";